<template>
  <form @submit.prevent="onSubmit()" autocomplete="off">
    <p class="text-center text-2">
      {{ $t('Verification code will be sent to the email address you typed.') }}
      <span class="text-bold">
        {{ $t('The verification code is valid for 900 seconds.') }}
      </span>
      {{ $t('If the verification code is expired, send the email again.') }}
    </p>

    <p class="text-center text-bold">{{ $t('Type Six-digit verification code.') }}</p>
    <div class="form-group">
      <div class="mb-2">
        <el-progress
          type="line"
          :percentage="count"
          :show-text="false"
          :color="barColor()"
        ></el-progress>
      </div>
      <input
        name="code"
        class="form-control"
        :placeholder="$t('Six-digit verification code')"
        type="text"
        maxlength="6"
        v-model="inputDigits"
        :disabled="inputDisabled"
        @keyup="typeSomeKeys"
      />
      <span class="text-2 text-danger" v-if="digitsIsWrong">{{
        $t('This is wrong verification code.')
      }}</span>
    </div>
    <p class="resend" :class="{ disabled: isDisabled }" @click="reSend">
      {{ $t('Send email again.') }}
      <i class="fas fa-spinner fa-pulse mr-1" v-if="isDisabled"></i>
    </p>

    <div class="buttons-w">
      <div class="go-back">
        <span @click="goBack">{{ $t('Back') }}</span>
      </div>
      <div class="text-center">
        <Button nativeType="submit" :loading="isLoading" @click="onSubmit">
          {{ $t('Confirm submit') }}
        </Button>
      </div>
    </div>
  </form>
</template>

<script>
import Button from '@/components/uikit/Button';

import jaTranslations from '@/i18n/langs/ja';
import enTranslations from '@/i18n/langs/en';

export default {
  name: 'DigitsForm',
  components: {
    Button,
  },
  props: {
    verifyData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    user: {
      type: Object,
    },
  },
  i18n: {
    en: {
      ...enTranslations,
    },
    ja: {
      ...jaTranslations,
    },
  },
  data() {
    return {
      isLoading: false,
      inputDigits: '',
      digitsIsWrong: false,
      time: 900,
      value: 100,
      timerObj: null,
      isDisabled: false,
      inputDisabled: false,
    };
  },
  watch: {
    inputDigits(value) {
      this.inputDigits = value.replace(/\s+/g, '');
    },
  },
  mounted() {
    this.countDownStart();
  },
  computed: {
    count() {
      return this.value;
    },
  },
  methods: {
    countDown() {
      const time = this.time;

      this.value = this.value - 1;
      this.time = time - 9;

      if (time <= 0) {
        clearInterval(this.timerObj);
        this.inputDisabled = true;
      }
      
    },
    countDownStart() {
      const _this = this;
      this.timerObj = setInterval(function() {
        _this.countDown();
      }, 9000);
    },
    barColor() {
      if (this.time < 300 && this.time > 100) {
        return '#fbe4a0';
      } else if (this.time <= 100) {
        return '#e65252';
      }
    },
    reSend() {
      this.isDisabled = true;
      this.inputDisabled = true;
      this.$store
        .dispatch('postResetSend', {
          email: this.verifyData.email,
          username: this.user.id,
          level: this.user.level,
        })
        .then(res => {
          if (res.data.status === 'error') {
            throw new Error();
          } else {
            this.$emit('getVerifyData', res.data.data);
            this.time = 900;
            this.value = 100;
            this.countDownStart();
          }
          this.isDisabled = false;
          this.inputDisabled = false;
        })
        .catch(() => {
          this.$message.error(this.$t('An error has occurred.'));
          this.isDisabled = false;
          this.inputDisabled = false;
        });
    },
    goBack() {
      this.$emit('goForward', 0);
    },
    onSubmit() {
      this.isLoading = true;
      this.$store
        .dispatch('postResetVerify', {
          digits: this.inputDigits,
          hash: this.verifyData.hash,
          second: this.verifyData.second,
        })
        .then(res => {
          this.isLoading = false;
          if (res.data.status === 'error') {
            this.digitsIsWrong = true;
          } else {
            this.$emit('goForward', 2);
          }
        })
        .catch(() => {
          this.isLoading = false;
          this.digitsIsWrong = true;
          this.$message.error(this.$t('An error has occurred.'));
        });
    },
    typeSomeKeys() {
      this.digitsIsWrong = false;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../../assets/scss/mo-custom';
.go-back {
  span {
    color: $primary-color;
    cursor: pointer;
    line-height: 30px;
    &:hover {
      text-decoration: underline;
    }
  }
}
.resend {
  font-size: 0.8rem;
  color: $primary-color;
  cursor: pointer;
  text-align: center;
  &:hover {
    color: darken($primary-color, 10%);
    text-decoration: underline;
  }
}
.disabled {
  color: $mute-color;
  cursor: not-allowed;
  &:hover {
    text-decoration: none;
  }
}
</style>
